import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=8912d336&"
import script from "./SecuritySetting.vue?vue&type=script&lang=js&"
export * from "./SecuritySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SecuritySetting.vue"
export default component.exports